/* eslint-disable sort-keys */
import {
	requests
}from '../../../api/agent'

export default {
	getMessageTemplates          : (params) => requests.getWithParams('/MessageTemplate/list', params),
	getLocalMessageTemplate      : (params) => requests.getWithParams('/LocalMessageTemplate/list', params),
	create                       : params => requests.post('/MessageTemplate/create', params),
	createLocalMessageTemplate   : params => requests.post('/LocalMessageTemplate/create', params),
	delete                       : params => requests.post('/MessageTemplate/delete', params),
	deleteLocalMessageTemplate   : params => requests.post('/LocalMessageTemplate/delete', params),
	getOrgDocumentScale          : (params) => requests.getWithParams('/OrgDocumentScale/GetOrgDocumentScale', params),
	DownloadDocumentScaleExample : params => requests.getFile('/OrgDocumentScale/DownloadDocumentScaleExample', params),
	addOrgDocumentScale          : params => requests.post('/OrgDocumentScale/AddOrgDocumentScale', params),
	DownloadDocumentScale        : params => requests.getFile('/OrgDocumentScale/DownloadOrgDocumentScaleFile', params),
	GetOrgDocumentScales         : params => requests.getWithParams('/OrgDocumentScale/GetOrgDocumentScale', params)
}